import {BaseButton} from "components"
import CampusSelect from "components/CampusSelect"
import {FormLabel} from "components/Form"
import {BasePopup} from "components/popup"
import UserSelect from "components/UserSelect"
import {handleError} from "helpers"
import {useEffect, useState} from "react"
import {leadBucketSettingsService} from "services"
import {Auth} from "types/auth"
import styles from "./DuplicatedLeadNotificationRecipientForm.module.css"
import {
    DuplicatedLeadNotificationCampusLabel,
    DuplicatedLeadNotificationCampusMap,
    DuplicatedLeadNotificationRecipientItem
} from "types/settings/lead-bucket-settings"
import {useMutation} from "hooks"

type Props = {
    item?: DuplicatedLeadNotificationRecipientItem
    open: boolean
    onClose: () => void
    onSuccess?: () => void
}

export function DuplicatedLeadNotificationRecipientForm(props: Props) {
    const {item, open, onClose, onSuccess} = props
    const [currentItem, setCurrentItem] = useState<DuplicatedLeadNotificationRecipientItem>()
    const isEdit = !!item
    const isAllCampusOrNoCampus = (campusName) =>
        campusName === DuplicatedLeadNotificationCampusLabel.ALL_CAMPUSES ||
        campusName === DuplicatedLeadNotificationCampusLabel.NO_CAMPUS

    const submitMutation = useMutation(
        async () => {
            const allOrNone = isAllCampusOrNoCampus(currentItem?.campus.name)
            const payload = {
                recipientProfileId: currentItem?.users?.map((item) => item.profileId),
                campusId: allOrNone ? null : (currentItem?.campus?.id as number),
                receiveNotificationsFor: allOrNone
                    ? DuplicatedLeadNotificationCampusMap[currentItem?.campus.name]
                    : DuplicatedLeadNotificationCampusMap[DuplicatedLeadNotificationCampusLabel.SINGLE_CAMPUS]
            }
            if (isEdit) {
                return await leadBucketSettingsService.updateAdmissionsLeadBucket(payload)
            } else {
                return await leadBucketSettingsService.createAdmissionsLeadBucket(payload)
            }
        },
        {
            onSuccess,
            onError: handleError
        }
    )

    const onChangeData = (key: string, value: any) => {
        const curr = {...currentItem}
        curr[key] = value
        setCurrentItem(curr)
    }

    useEffect(() => {
        setCurrentItem(item)
    }, [item])

    return (
        <BasePopup
            isShow={open}
            onClose={onClose}
            leftIcon={isEdit ? "PENCIL" : "PLUS_CIRCLE"}
            leftIconColor="#fff"
            width="40vw"
            closable
            destroyOnClose>
            <div className={styles.headingTitle}>{isEdit ? "Edit Lead Bucket" : "Add Lead Bucket"}</div>
            <div className={styles.field}>
                <FormLabel label="Campus" />
                <CampusSelect
                    isDisabled={isEdit}
                    isClearable
                    value={currentItem?.campus}
                    onChange={(value) => onChangeData("campus", value)}
                    additionalValues={[
                        DuplicatedLeadNotificationCampusLabel.ALL_CAMPUSES,
                        DuplicatedLeadNotificationCampusLabel.NO_CAMPUS
                    ]}
                />
            </div>
            <div className={styles.field}>
                <FormLabel label="Staff" />
                <UserSelect
                    isClearable
                    type={Auth.UserProfileType.Staff}
                    value={currentItem?.users}
                    onChange={(value) => onChangeData("users", value ?? [])}
                    isMulti
                />
            </div>
            <div className={styles.doneBtn}>
                <BaseButton
                    title="Submit"
                    onClick={submitMutation.mutate}
                    className={styles.saveBtn}
                    loading={submitMutation.isLoading}
                />
            </div>
        </BasePopup>
    )
}
